const toTrimmedString = (value) => {
    const normalized = String(value || '').trim();
    return normalized || null;
};

export const normalizeSubjectId = (value) => toTrimmedString(value);

export const normalizeExecutionId = (value) => toTrimmedString(value);

export const normalizeRequestId = (value) => toTrimmedString(value);

export const normalizeOriginalImageHashId = (value) => toTrimmedString(value);

export const normalizeProcessedImageHashId = (value) => toTrimmedString(value);

export const normalizeReferenceCode = (value) => toTrimmedString(value);

export const normalizePresetStyleId = (value) => toTrimmedString(value);

export const buildAnalysisPrimaryKeys = ({
    subjectId = null,
    executionId = null,
    requestId = null
} = {}) => ({
    subjectId: normalizeSubjectId(subjectId),
    executionId: normalizeExecutionId(executionId),
    requestId: normalizeRequestId(requestId)
});

export const hasAnalysisPrimaryKeys = ({
    subjectId = null,
    executionId = null,
    requestId = null
} = {}) => Boolean(
    normalizeSubjectId(subjectId) ||
    normalizeExecutionId(executionId) ||
    normalizeRequestId(requestId)
);
